import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Container, Row, Col } from 'react-bootstrap';
import { FiUser, FiSearch, FiShoppingBag, FiMenu } from 'react-icons/fi';
import SearchModal from './SearchModal';
import LoginOffcanvas from './LoginOffcanvas';
import MobileMenu from './MobileMenu';
import ProductCard from './ProductCard';
import { STOREFRONT_BRAND } from '../utils/brandAssets';
import styles from './bodywon.module.css';

const navLinks = [
  {
    name: 'NEW IN',
    path: '#new-in',
    megaMenu: {
      columns: [
        { title: 'COMOS DE MILANO', links: [{ name: 'Fermentum Loremous', path: '#' }, { name: 'Habitasse Molateas', path: '#' }] },
        { title: 'LOREM DE DORUS', links: [{ name: 'Fermentum Loremous', path: '#' }, { name: 'Habitasse Molateas', path: '#' }] },
        { title: 'MILANCELOS A LANOS', links: [{ name: 'Best Selling', path: '#' }, { name: 'Fermentum Loremous', path: '#' }] },
      ]
    }
  },
  {
    name: 'COLLECTIONS',
    path: '#collections',
    megaMenu: {
      columns: [
        { title: 'NOR LOREMIRUS', links: [{ name: 'Best Selling', path: '#' }, { name: 'Fermentum Loremous', path: '#' }] },
        { title: 'SALE OFFERS', links: [{ name: 'Best Selling', path: '#' }, { name: 'Fermentum Loremous', path: '#' }] },
        { title: 'SHOP', links: [{ name: "Editor's Picks", path: '#' }, { name: 'Just Added', path: '#' }] },
      ],
      products: [
        { id: 101, name: 'Hangerie (Product 1) Sample', price: 469.00, imageSrc: '/img/_91A5118.JPG', rating: 4, colors: [], isNew: false },
        { id: 102, name: 'Hangerie (Product 2) Sample', price: 299.00, imageSrc: '/img/_91A5151.JPG', rating: 5, colors: [], isNew: false },
      ]
    }
  },
  {
    name: 'TREND NOW',
    path: '#trend-now',
    megaMenu: {
      columns: [
        { title: 'SUMMER TRENDS', links: [{ name: 'Light Fabrics', path: '#' }, { name: 'Floral Prints', path: '#' }] },
        { title: 'WINTER STYLES', links: [{ name: 'Cozy Knitwear', path: '#' }, { name: 'Layering Essentials', path: '#' }] },
      ],
      products: [
        { id: 103, name: 'Hangerie (Product 3) Sample', price: 85.00, imageSrc: '/img/_91A5083.JPG', rating: 3, colors: [], isNew: true, originalPrice: 99.00 },
        { id: 104, name: 'Hangerie (Product 4) Sample', price: 110.00, imageSrc: '/img/_91A5105.JPG', rating: 4, colors: [], isNew: false },
      ]
    }
  },
  {
    name: 'BRAS',
    path: '#bras',
    megaMenu: {
      columns: [
        { title: 'BY STYLE', links: [{ name: 'T-Shirt Bra', path: '#' }, { name: 'Push-Up Bra', path: '#' }] },
        { title: 'BY COVERAGE', links: [{ name: 'Full Coverage', path: '#' }, { name: 'Medium Coverage', path: '#' }] },
      ],
      products: [
        { id: 105, name: 'Hangerie (Product 5) Sample', price: 49.00, imageSrc: '/img/_91A5167.JPG', rating: 5, colors: [], isNew: false },
        { id: 106, name: 'Hangerie (Product 6) Sample', price: 79.00, imageSrc: '/img/_91A5082.JPG', rating: 5, colors: [], isNew: true, originalPrice: 120.00 },
      ]
    }
  },
  { name: 'DEMO', path: '#demo' },
  { name: 'PAGE', path: '#page' },
  { name: 'TRY THEME', path: '#try-theme' },
];

const BodywonHeader = ({
  cartItemCount,
  onCartClick,
  onAddToCart,
  showLogin: showLoginProp,
  setShowLogin: setShowLoginProp,
  onLoginSuccess,
  onLogoutSuccess,
}) => {
  const [showSearchModal, setShowSearchModal] = useState(false);
  const [showMobileMenu, setShowMobileMenu] = useState(false);
  const [showLoginLocal, setShowLoginLocal] = useState(false);
  const showLogin = showLoginProp ?? showLoginLocal;
  const setShowLogin = setShowLoginProp ?? setShowLoginLocal;

  return (
    <>
      <header className={styles.header}>
        <Container>
          <div className={styles.navbar}>
            <div className={`d-lg-none ${styles.mobileNavLeft}`}>
              <FiMenu size={24} className={styles.icon} onClick={() => setShowMobileMenu(true)} />
              <FiSearch size={22} className={styles.icon} onClick={() => setShowSearchModal(true)} />
            </div>

            <div className={styles.logo}>
              <Link to="/" aria-label="BodyWon Home">
                <img src={STOREFRONT_BRAND.logo} alt="Bodywon Logo" className={styles.logoImg} />
              </Link>
            </div>

            <nav className={`d-none d-lg-flex ${styles.navLinksDesktop}`}>
              {navLinks.map(link => (
                <div key={link.name} className={styles.navItem}>
                  <a href={link.path} className={styles.navLink}>
                    {link.name}
                  </a>
                  {link.megaMenu && (
                    <div className={styles.megaMenu}>
                      <Container>
                        <Row>
                          {link.megaMenu.columns.map((col, index) => (
                            <Col key={index}>
                              <h5 className={styles.megaMenuTitle}>{col.title}</h5>
                              <ul className={styles.megaMenuList}>
                                {col.links.map(subLink => (
                                  <li key={subLink.name}>
                                    <a href={subLink.path}>{subLink.name}</a>
                                  </li>
                                ))}
                              </ul>
                            </Col>
                          ))}
                          {link.megaMenu.products && (
                            <Col lg={5}>
                              <h5 className={styles.megaMenuTitle}>TOP SELLERS</h5>
                              <div className={styles.megaMenuProducts}>
                                {link.megaMenu.products.map((prod) => (
                                  <ProductCard key={prod.id} product={prod} onAddToCart={onAddToCart} />
                                ))}
                              </div>
                            </Col>
                          )}
                        </Row>
                      </Container>
                    </div>
                  )}
                </div>
              ))}
            </nav>

            <div className={styles.navIcons}>
              <FiUser size={22} className={styles.icon} onClick={() => setShowLogin(true)} />
              <FiSearch size={22} className={`d-none d-lg-block ${styles.icon}`} onClick={() => setShowSearchModal(true)} />
              <div className={styles.cartIcon} onClick={onCartClick}>
                <FiShoppingBag size={22} className={styles.icon} />
                {cartItemCount > 0 && (
                  <span className={styles.cartCount}>{cartItemCount}</span>
                )}
              </div>
            </div>
          </div>
        </Container>
      </header>

      <SearchModal
        show={showSearchModal}
        onHide={() => setShowSearchModal(false)}
        onAddToCart={onAddToCart}
      />
      <LoginOffcanvas
        show={showLogin}
        onHide={() => setShowLogin(false)}
        onLoginSuccess={onLoginSuccess}
        onLogoutSuccess={onLogoutSuccess}
      />
      <MobileMenu
        show={showMobileMenu}
        onHide={() => setShowMobileMenu(false)}
        navLinks={navLinks}
        onAddToCart={onAddToCart}
      />
    </>
  );
};

export default BodywonHeader;
